import { IHttpClient } from '@/core/services/http'
import { SupportNumberResponse } from '../types/api-responses/support-number'

export function createGetSupportNumberUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function () {
    try {
      const response = await httpClient.version('v1').get<{
        data: SupportNumberResponse
      }>('/website/customer/supportNumber', {
        headers: { 'Content-Type': 'application/json' },
      })

      return response.data.data.supportNumber
    } catch (_) {
      return ''
    }
  }
}
